import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { Language as MotherTongue } from '@lx/language';
import { MotherTongueService } from '@lx/shared/data-access/destination';
import { SharedModule } from 'primeng/api';
import { ListboxModule } from 'primeng/listbox';
import { SelectorField } from '@lx/quote-tool/lite/shared/ui/directives';
import { getCustomFormComponentControlValueAccessorProvider } from '@lx/quote-tool/lite/shared/utils';
import { DropdownSidePanelFieldComponent } from '@lx/quote-tool/lite/shared/ui/components';

@Component({
  standalone: true,
  selector: 'lx-mother-tongue-selector',
  imports: [ListboxModule, SharedModule, FormsModule, DropdownSidePanelFieldComponent],
  templateUrl: './mother-tongue-selector.component.html',
  styleUrls: ['./mother-tongue-selector.component.scss'],
  providers: [getCustomFormComponentControlValueAccessorProvider(MotherTongueSelectorComponent)],
})
export class MotherTongueSelectorComponent extends SelectorField<string> implements OnInit {
  @Input() title: string;
  motherTongues: MotherTongue[] = [];

  private readonly motherTongueService = inject(MotherTongueService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.motherTongueService
      .getAll()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((motherTongues: MotherTongue[]) => {
        this.motherTongues = motherTongues;
      });
  }
}
